import { cutCorners, getCardStyles, getGradients } from '../themes/themeExtensions'

// Theme-aware dashboard card styles
export const getDashboardCardStyles = (theme) => {
  const cardStylesTheme = getCardStyles(theme)
  const gradientsTheme = getGradients(theme.palette.mode)
  return {
    root: {
      ...cardStylesTheme.root,
      background: gradientsTheme.card,
    },
    content: cardStylesTheme.content,
    title: cardStylesTheme.title,
  }
}

// An embedded map: hairline ring, cut corners
const mapFrame = (theme) => ({
  ...cutCorners(10, theme.palette.divider),
  width: '100%',
  overflow: 'hidden',
})

// Cycle Times component styles - theme-aware
export const getCycleTimesStyles = (theme) => {
  const cardStylesTheme = getDashboardCardStyles(theme)
  return {
    root: cardStylesTheme.root,
    content: cardStylesTheme.content,
    title: cardStylesTheme.title,
    chart: {
      width: '100%',
      height: 300,
    },
    chartGrid: {
      stroke: theme.palette.divider,
    },
    chartAxis: {
      fill: theme.palette.text.secondary,
      fontSize: 12,
    },
  }
}

// Disengagement Maps component styles - theme-aware
export const getDisengagementMapStyles = (theme) => {
  const cardStyles = getDashboardCardStyles(theme)
  return {
    root: cardStyles.root,
    content: cardStyles.content,
    title: cardStyles.title,
    map: {
      ...mapFrame(theme),
      height: 400,
    },
    caption: {
      color: theme.palette.text.secondary,
    },
  }
}

// Site Location component styles - theme-aware
export const getSiteLocationStyles = (theme) => {
  const cardStyles = getCardStyles(theme)
  return {
    root: cardStyles.root,
    content: cardStyles.content,
    title: {
      ...cardStyles.title,
      color: theme.palette.text.primary,
    },
    map: {
      ...mapFrame(theme),
      height: '100%',
      minHeight: 200,
    },
  }
}

// System Versions component styles - theme-aware
export const getSystemVersionsStyles = (theme) => {
  const cardStyles = getDashboardCardStyles(theme)
  return {
    root: cardStyles.root,
    content: cardStyles.content,
    title: cardStyles.title,
  }
}

// Status component styles - theme-aware
export const getStatusStyles = (theme) => {
  const cardStyles = getDashboardCardStyles(theme)
  return {
    root: cardStyles.root,
    content: cardStyles.content,
    title: cardStyles.title,
    statusContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      mt: 2,
    },
    statusText: {
      color: theme.palette.text.primary,
    },
  }
}
